import { IconSun } from './IconSun'

export default IconSun
